<template>
    <div class="Offers">
		<div class="Offers__header">
			<h4>{{ $t('OffersHeader') }}</h4>
		</div>
        <div class="Offers__container">
			<Offer 
				v-for="offer in offers" 
				:key="offer.id" 
				:title="offer.title"
				:imgID="offer.img"
			/>
        </div>
    </div>
</template>

<script>
import Offer from './Offer'
export default {
    name: 'Offers',
	components: {
		Offer
	},
    computed: {
		offers() {
			return [
				{ title: this.$t('OfferTitleKonsultacija'), id: 1, img: 'konsultacija' },
				{ title: this.$t('OfferTitleDizajn'), id: 2, img: 'dizajn-priprema' },
				{ title: this.$t('OfferTitleStampa'), id: 3, img: 'stampa' },
				{ title: this.$t('OfferTitleMontaza'), id: 4, img: 'montaza' }
			]
		}
    }
}
</script>

<style lang="scss" scoped>

.Offers {
	padding: 50px 30px;
    background: lighten($blue, 10);

	&__header {
		width: 100%;
		text-align: center;
		margin-bottom: 30px;
	}

	h4 {
		font-size: 1.8em;
		margin: 0;
		color: white;
		font-weight: 400;
	}
}

@media screen and (min-width: 768px) {
	.Offers {
		
		&__container {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-evenly;
		}

		h4 {
			font-size: 3em;
		}
	}
}
</style>
